import { differenceInCalendarMonths, parseISO } from 'date-fns'

import type { TSimulacaoCalculoPrazo } from '@/domain/simulador/factories/types/simulacao-calculo'
import { CalculadorPrazoBase } from '@/features/simulador/brasil/domain/calculador-prazo-base'

export class CalculadorPrazoPrice extends CalculadorPrazoBase {
  constructor(grupos: TSimulacaoCalculoPrazo) {
    super(grupos)
  }

  override calcular() {
    const { prazoEntregaEmMeses, isEmpreendimentoEntregue } = this.calcularPrazoEntrega()

    const dataPrimeiraEntrada = this.getDataPrimeiraEntrada()
    const dataReferencia = dataPrimeiraEntrada ?? parseISO(this.grupos.dataSimulacao)

    const dataUltimaMensalOuIntermediaria = this.getDataUltimaMensalOuIntermediaria()

    const prazoPagamentoEmMeses =
      dataReferencia && dataUltimaMensalOuIntermediaria
        ? differenceInCalendarMonths(dataUltimaMensalOuIntermediaria, dataReferencia)
        : 0

    return { prazoPagamentoEmMeses, prazoEntregaEmMeses, isEmpreendimentoEntregue }
  }
}
